import * as React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { Modal } from 'react-inv-forms';
import { Select } from 'antd';
import StringBuilder from '../../../../helpers/StringBuilder';

const { Option } = Select;

interface Props extends WithTranslation {
  /** tablica id pracowników dostępnych już w tabeli realizatorów przedmiotu */
  alreadySelected: number[];
  /** callback wykonywany na przycisku "Potwierdź" */
  onAddRealizatorzy: (list: number[]) => void;
  /** callback wykonywany na przycisku "Anuluj" */
  onClose: () => void;
  /** callback wykonywany po wuybraniu nauczyciela z listy rozwijanej */
  onSelectRealizator: (list: any[]) => void;
  /** stan modala w redux (zawiera dane do wyświetlenia, stan ładowania, otwarcia, wybranych nauczycieli) */
  realizatorzyListModal: Modal.Realizatorzy;
}
/**
 * Komponent modala wyboru realizatorów przedmiotu
 *
 */
export class RealizatorzyListModal extends React.Component<Props> {
  onChange = (keys: number[]): void => {
    const fullSelectedList = this.props.realizatorzyListModal.realizatorzyList
      .map(item => (keys.includes(item.prowadzacyPId) ? { ...item, key: item.prowadzacyPId } : null))
      .filter(item => item !== null);
    this.props.onSelectRealizator(fullSelectedList);
  };
  filterOption = (inputValue: string, option: any) => {
    const escaped = StringBuilder.escapeRegExp(inputValue.trim());
    const regex = new RegExp(escaped, 'i');
    if (option) return regex.test(option.label);
    else return true;
  };
  render(): React.ReactElement {
    const { opened, loading, realizatorzyList, selected } = this.props.realizatorzyListModal;
    return (
      <Modal
        visible={opened}
        okText={this.props.t('CONFIRM')}
        cancelText={this.props.t('CANCEL')}
        onCancel={this.props.onClose}
        confirmLoading={loading}
        onOk={selected.length ? this.props.onAddRealizatorzy.bind(null, selected) : this.props.onClose}
        title={this.props.t('REALIZATORZY_MODAL_LIST')}
        destroyOnClose
        className='cySubjectCardRealizer'
      >
        <h3>{this.props.t('REALIZATORZY_MODAL_CHOOSE')}:</h3>
        <Select
          mode='multiple'
          allowClear
          loading={loading}
          showSearch
          placeholder={this.props.t('START_TYPING')}
          onChange={this.onChange}
          notFoundContent={this.props.t('NO_DATA')}
          filterOption={this.filterOption}
          dropdownClassName='custom_dropdown'
          className='custom_select'
          optionLabelProp='label'
          autoFocus
        >
          {realizatorzyList.map(realizator => (
            <Option
              key={realizator.prowadzacyPId}
              value={realizator.prowadzacyPId}
              className='custom_option'
              disabled={this.props.alreadySelected.includes(realizator.prowadzacyPId)}
              label={`${realizator.prowadzacyImie} ${realizator.prowadzacyNazwisko}`}
            >
              {`
              ${realizator.prowadzacyTytul ? realizator.prowadzacyTytul : ''}
              ${realizator.prowadzacyImie}
              ${realizator.prowadzacyNazwisko}
              (${realizator.prowadzacyJednostka.map((unit: string, idx: number) => `${idx === 0 ? '' : ' '}${unit}`)})
              `}
            </Option>
          ))}
        </Select>
      </Modal>
    );
  }
}
export default withTranslation()(RealizatorzyListModal);
